<!--
    <template>
      <main class="add-list-modal flexContainers">
        <div class="add-list abs">
          <header>
            <i @click="close"></i>
          </header>
          <main class="create-list-main">
            <label class="" for="listName">{{$t('addlist.label')}}</label>
            <input type="text" id="listName" v-model="name"/>
          </main>
          <footer>
            <button class="btnExp" @click="save">{{ $t('addlist.add') }}</button>
          </footer>
        </div>
      </main>
    </template>
-->
<template>
    <section>
        <transition-group name="modal">
            <div id="brand" class="modal-mask" key="brand">
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody">
                            <div class="modalContent">
                                <label for="listName">{{ $t("addlist.label") }}</label>
                                <input type="text" class="textfield" id="listName" v-model="name" /> <br />
                                <span v-if="name === ''" style="color:red">Veuillez saisir un nom</span>
                            </div>
                            <br />
                            <div class="flexContainer fright">
                                <button class="btn block pointer uppercase cancel" @click="close();">{{ $t("common.cancel") }}</button>
                                <button class="btnExp" @click="save">{{ $t("addlist.add") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
    data() {
        return {
            name: ""
        };
    },
    computed: {
        ...mapGetters({
            isDisplayAddList: "catalog/wishlist/isDisplayAddList",
            getLists: "catalog/wishlist/getLists"
        })
    },
    created() {},
    mounted() {
        document.getElementById("listName").focus();
    },
    methods: {
        ...mapActions({
            setDisplayAddList: "catalog/wishlist/setDisplayAddList",
            addList: "catalog/wishlist/addList"
        }),
        close() {
            this.setDisplayAddList(false);
            // window.location.reload()
        },

        save() {
            if (this.name !== "") {
                this.addList({ name: this.name, data: null });
                this.close();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.listComponent {
    margin-bottom: 10px;
}
.cancel {
    margin-right: 10px;
}
.logoRem3rch {
}

.selectCampaign {
    border: none;
    border-bottom: 1px solid #343434;
    width: 100%;
    font-size: 14px;
    font-family: Roboto;
}

.zones {
    overflow-y: scroll;
    height: 100px;
}

.boutonSaveDelete {
    margin-left: 290px;
    .save {
        margin-right: 12px;
    }
}

.help {
    margin-top: 20px;
    margin-left: 262px;
}

#spinnerLoader {
    left: 0;
    top: 50%;
    width: 100%;
    .loader {
        margin: auto;
    }
}

.teinteCert {
    padding-left: 60px;
}

.zoneChecked {
    margin-left: 2px;
}

.campaignTable {
    width: 40%;
    padding-bottom: 12px;
}

.productShadeTitle {
    font-family: "Oswald", Sans-Serif;
}

.inputShades {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
}

.labelInput {
    margin-top: 2px;
    font-family: Roboto;
    font-weight: bold;
    font-size: 1.17em;
    padding-left: 20px;
    padding-right: 10px;
}

.labelInputShades {
    margin-top: 2px;
    font-family: Roboto;
    font-size: 1.17em;
    padding-right: 10px;
}

/* height firefox modal */
._modalWrapper_ {
    height: auto;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 77px;
        right: 300px;
        z-index: 2;
    }
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            background: #fff;
            /*width: 500px;*/
            height: auto;
            border-radius: 4px;
            padding: 15px;
            margin: auto;
            .modalContent {
                h2 {
                    font-size: 1.6rem;
                }
                p {
                    font-size: 1.4rem;
                    margin: 30px 0;
                }
                #favoriteName {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid #343434;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// AddList.vue?f154a0ee